import styled from "styled-components";

export const Container = styled.section`
  padding: 120px 0;
  .social-content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin-top: 48px;
    .sm-card {
      padding: 16px;
      display: flex;
      text-align: center;
      justify-content: center;
      width: 120px;
      a {
        text-decoration: none;
        color: var(--primaryColor);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 16px;
        text-align: center;
        width: 120px;
        img {
          width: 64px;
          height: 64px;
          margin-bottom: 8px;
        }
        p {
          font-size: 16px;
          line-height: 1.5;
          text-decoration: none;
        }
      }
    }
  }
`;
